module.exports = __webpack_public_path__ + "static/media/icon-close.46c03b12.svg";